module.exports = __webpack_public_path__ + "static/media/car-insurance_640_color.e2a50d33.png";